/* eslint-disable import/named */
import RestaurantSource from '../../data/restaurant-source';
import { restoItemTemplate, createSkeletonRestoTemplate } from '../templates/template-creator';
import '../components/loading-element';
import '../components/fail-request';

const ListResto = {
  async render() {
    return `
    <h1 class="main-title" id="konten">Restaurant Catalogue</h1>
    <article class="container-content" id="katalog">
      ${createSkeletonRestoTemplate(20)}
    </article>`;
  },

  async afterRender() {
    const loading = document.querySelector('loading-element');
    const fail = document.querySelector('fail-request');
    loading.style.display = 'block';
    fail.style.display = 'none';
    try {
      const data = await RestaurantSource.getAllResto();
      const katalog = document.getElementById('katalog');
      katalog.innerHTML = '';
      data.forEach((item) => {
        katalog.innerHTML += restoItemTemplate(item);
      });
    } catch {
      fail.style.display = 'block';
      const footer = document.querySelector('footer');
      const main = document.getElementById('main');
      const hero = document.getElementById('hero');
      main.style.display = 'none';
      hero.style.display = 'none';
      footer.style.display = 'none';
    } finally {
      loading.style.display = 'none';
    }
  },
};

export default ListResto;
